// extracted by mini-css-extract-plugin
export default {"files_rows":"index_files_rows__O4Xaq","group_header":"index_group_header__+4jUF","flies_group":"index_flies_group__xs05n"};